const index = () => import('./Index');
const indexProg = () => import('./indexProg')

//园区处重点项目管理
export default {
  routes: [
    {
      path: '/park/major/v2022/index',
      name: 'park_major_2022_index',
      component: index
    },
    {
      path: '/park/major/v2022/prog/index',
      name: 'park_major_2022_prog_index',
      component: indexProg
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/major/park/v2022/router.js